import { Grid, Typography } from "@mui/material";
import transmitSuccess from "./img/TransmitSuccess.jpg";
import StyledButton from "../dashboard/StyledButton";
import { useEffect } from "react";
import { trackEvent } from "src/Amplitude";

export default function TransmitVerifySuccess() {
  useEffect(() => {
    trackEvent("Guest Viewed Thank you Page", { guestStatus: "pending" }, "Onboarding");
  }, []);

  const supportArticleUrl =
    "https://support.calebandbrown.com/en/articles/5826680-navigating-the-portal";

  const successMessage =
    "We have successfully received your application. Thank you for taking the time to complete these steps.";

  return (
    <Grid
      item
      xs={12}
      sx={{
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        textAlign: "center",
      }}>
      <Grid
        item
        xs={12}
        sx={{
          background: "#F0FEF9",
          borderRadius: "8px",
          textAlign: "center",
          padding: "8px 16px",
          marginBottom: "48px",
        }}>
        <Typography sx={{ fontSize: "14px", fontWeight: 400 }}>{successMessage}</Typography>
      </Grid>
      <Grid item xs={12} sx={{ marginBottom: "48px" }}>
        <img src={transmitSuccess} alt="Success" />
      </Grid>
      <Grid item xs={12} sx={{ marginBottom: "48px", maxWidth: "843px", alignSelf: "center" }}>
        <Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
          Most accounts are verified within minutes. In rare cases, the process can take 24–48
          hours.
          <br /> <br />
          Our Onboarding team is currently reviewing your application. You'll receive an email from{" "}
          <a href={`mailto:${"onboarding@calebandbrown.com"}`} style={{ color: "#FC4C4C" }}>
            onboarding@calebandbrown.com
          </a>{" "}
          or a team member once the review is complete. If you have any further questions, please
          reach out to our Support team using the chat icon in the bottom-right corner.
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <StyledButton onClick={() => window.open(supportArticleUrl, "_blank")}>
          How to Navigate Portal
        </StyledButton>
      </Grid>
    </Grid>
  );
}
